/**
 * 路由白名单，只要是这里设置的不登陆也不会跳转到登陆页面,在fetch.js里面调用
 */
export default ['/', '/home', '/user/login', '/eu', '/eu/customize', '/pc', '/pc/bill', '/user/register', '/promotion', '/school/knowledge/artdetail', '/qrcode/preview', '/school/training', '/school/training/detail']


// WEBPACK FOOTER //
// ./src/utils/whiteList.js